import type { ApiData } from './types';
import type { RouteParams } from 'nextjs/types';

import type { Route } from 'nextjs-routes';

import * as cookies from 'lib/cookies';
import { getStoredLocale } from 'lib/i18n/resolveLocale';
import type { Locale } from 'lib/i18n/types';
import { DEFAULT_LOCALE } from 'lib/i18n/translations';

import generate from './generate';

function getCurrentLocale(): Locale {
  return getStoredLocale() ?? DEFAULT_LOCALE;
}

export default function update<Pathname extends Route['pathname']>(
  route: RouteParams<Pathname>,
  apiData: ApiData<Pathname>,
  locale: Locale = getCurrentLocale(),
) {
  const { title, description } = generate(route, apiData, locale);

  window.document.title = title;
  window.document.querySelector('meta[name="description"]')?.setAttribute('content', description);
}
